define('v3/Common/Models/Pupils.Model',[
	'knockout',
	'lodash'
], function (ko, _) {
	return function PupilModel (pupil, selectedIds) {
		var self = this;

		self.id = pupil.id;

		self.firstName = pupil.firstName;
		self.lastName = pupil.lastName;
		self.firstNameForSorting = pupil.firstNameForSorting && pupil.firstNameForSorting.trim();
		self.lastNameForSorting = pupil.lastNameForSorting && pupil.lastNameForSorting.trim();
		self.shortName = pupil.shortName;
		self.longName = pupil.longName;
		self.userName = pupil.userName;
		self.emailAddress = pupil.emailAddress;
		self.grade = pupil.grade;
		self.gradeName = pupil.gradeName;

		self.isSelected = ko.computed({
			read: function () { return selectedIds().indexOf(self.id) > -1; },
			write: function (val) {
				if (val) {
					if (selectedIds().indexOf(self.id) === -1) selectedIds.push(self.id);
				} else {
					selectedIds(_.without(selectedIds(), self.id));
				}
			}
		});
		self.toggleSelection = function () {
			var current = self.isSelected();
			self.isSelected(!current);
		};
	};
});
